export interface ParteDanificada {
  codigo: number;
  descricao: string;
  valorIntegracao: string;
}
const PARA_CHOQUE: ParteDanificada = {
  codigo: 1,
  descricao: "Para-choque",
  valorIntegracao: "PARA_CHOQUE",
};
const LATERAL: ParteDanificada = {
  codigo: 2,
  descricao: "Lateral do veículo",
  valorIntegracao: "LATERAL",
};
const TRASEIRA: ParteDanificada = {
  codigo: 3,
  descricao: "Traseira do veículo",
  valorIntegracao: "TRASEIRA",
};
export const OUTROS: ParteDanificada = {
  codigo: 4,
  descricao: "Outros",
  valorIntegracao: "OUTRO",
};

export const PARTES_DANIFICADAS: ParteDanificada[] = [
  PARA_CHOQUE,
  LATERAL,
  TRASEIRA,
  OUTROS,
];
